<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6" lg="6">
              <el-text-field
                label="Objektas"
                disabled
                v-model="formData.object_title"
                :maxlength="20"
              />
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <el-text-field
                label="Rolė objekte"
                disabled
                v-model="formData.role_in_object"
                :maxlength="20"
              />
            </v-col>
          </v-row>

          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <h3>Mirties faktas</h3>
                <el-checkbox
                  class="my-0"
                  style="width: fit-content;"
                  label="Tikrinti asmens mirties faktą ASMENYS"
                  v-model="formData.is_dead_checked"
                >
                </el-checkbox>
              </v-col>
              <v-col cols="12" class="mb-0 pb-0">
                <el-textarea
                  required
                  label="Klaidos pranešimas lietuvių kalba (Mirties faktas)"
                  v-model="formData.message_dead_lt"
                  maxlength="500"
                />
              </v-col>
              <v-col cols="12" class="mb-0 pb-0">
                <el-textarea
                  required
                  label="Klaidos pranešimas anglų kalba (Mirties faktas)"
                  v-model="formData.message_dead_en"
                  maxlength="500"
                />

                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <h3>Asmens neveiksnumas</h3>
                <el-checkbox
                  class="my-0"
                  style="width: fit-content;"
                  label="Tikrinti asmens neveiksnumą NIRVAR"
                  v-model="formData.is_nirvar_checked"
                >
                </el-checkbox>
              </v-col>

              <v-col cols="12" class="ml-0 pl-0">
                <el-select-table
                  title="NIRVAR sritys. Pasirenkamos sritys, kurioms leidžiama gauti paslaugą."
                  elKey="nirvars"
                  :available-items="nirvars"
                  :selected-items="formData.nirvars"
                  availableTitle="Galimos reikšmės"
                  selectedTitle="Pasirinktos išimtys"
                  item-key="value"
                  item-name="text"
                  @move-to-selected="moveToSelected"
                  @move-to-available="moveToAvailable"
                />
              </v-col>
              <v-col cols="12" class="mb-0 pb-0">
                <el-textarea
                  required
                  label="Klaidos pranešimas lietuvių kalba (Asmens neveiksnumas)"
                  v-model="formData.message_nirvar_lt"
                  maxlength="500"
                />
              </v-col>
              <v-col cols="12" class="mb-0 pb-0">
                <el-textarea
                  required
                  label="Klaidos pranešimas anglų kalba (Asmens neveiksnumas)"
                  v-model="formData.message_nirvar_en"
                  maxlength="500"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <!-- modal  -->
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
import {classifiersGet} from "@/services/classifierService";

export default {
  components: {  },
  name: 'representativePersonRuleForm',
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: false,
      enumsClassifiers: [],
      formData: {},
      nirvars: [],
    }
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      return 'JA atstovų tikrinimo taisyklės'
    },
  },
  created() {
    this.enumsClassifiers = Enums
    this.getData()
  },
  mounted() {},
  beforeDestroy() {
    window.localStorage.setItem('presetCK', '1')
  },
  methods: {
    setEdit(item) {
      return item
    },
    back() {
      this.$router.push({ name: 'representativePersonRules' })
    },
    async getClassifiers() {
      this.enumsClassifiers = Enums
      this.loadDefault = true
      let requiredClassifiers = { classifiers: ['nirvar'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.nirvars = res.data.classifiers['nirvar']['lt']
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
      classifiersGet({ classifiers: ['nirvar']})
        .then(res => this.classifiers = res.data.classifiers)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally()
    },
    async getData() {
      await this.getClassifiers()
      this.pageloading = true
      this.$axios
        .get(`signatory-rules/${this.getId}/representatives`)
        .then((res) => {
          this.formData = res.data.signatoryRule
          // Ensure nirvars is an array
          if (!this.formData.nirvars || !Array.isArray(this.formData.nirvars)) {
            this.formData.nirvars = []
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          let url = `signatory-rules/${this.getId}/representatives`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    moveToSelected(itemToSelect, key) {
      console.log(this.formData)
      if (!this.formData[key].includes(itemToSelect.value)) {
        this.formData[key].push(itemToSelect.value);
      }

      if (key === 'nirvars') {
        this.formData[key].sort((a, b) => {
          const itemA = this.nirvars.find(item => item.value === a);
          const itemB = this.nirvars.find(item => item.value === b);

          if (itemA && itemB) {
            return itemA.text.localeCompare(itemB.text);
          }
          return 0; // Keep original order if items not found
        });
      } else {
        this.formData[key].sort((a, b) => a - b);
      }
    },
    moveToAvailable(itemToRemove, key) {
      const indexToRemove = this.formData[key].indexOf(itemToRemove.value);
      if (indexToRemove > -1) {
        this.formData[key].splice(indexToRemove, 1);
      }

      if (key === 'nirvars') {
        this.formData[key].sort((a, b) => {
          const itemA = this.nirvars.find(item => item.value === a);
          const itemB = this.nirvars.find(item => item.value === b);

          if (itemA && itemB) {
            return itemA.text.localeCompare(itemB.text);
          }
          return 0; // Keep original order if items not found
        });
      } else {
        this.formData[key].sort((a, b) => a - b)
      }
    }
  },
}
</script>
<style lang="scss">
.ck-editor__editable {
  min-height: 5000px;
}
</style>
